// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elLQZfOZLvsq0Aq2WN7S{align-items:center;gap:10px;width:100%;padding:8px 20px 12px;display:flex}.hBGn0dWRwNA9URzBvy8a{width:100%}.hBGn0dWRwNA9URzBvy8a>input{height:24px;font-size:16px;font-style:normal;font-weight:400;line-height:150%}.uJUuf9W604MZnrGdbGOB{width:100%;padding:24px 16px 24px 20px;position:relative}.gXVLXJBGBMEyikD8Ulmk{align-items:center;gap:7px;margin-top:30px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `elLQZfOZLvsq0Aq2WN7S`,
	"search": `hBGn0dWRwNA9URzBvy8a`,
	"container": `uJUuf9W604MZnrGdbGOB`,
	"actions": `gXVLXJBGBMEyikD8Ulmk`
};
export default ___CSS_LOADER_EXPORT___;
